<template>
  <loading-data v-if="loadData" />
  <div v-else>
    <edit-registry-modal
      v-if="showEditRegistryModal"
      :registryId="registryId"
      :field="fieldEdit"
      @closeModal="closeModalEditRegistry"
    />
    <delete-registry-modal
      v-if="showDeleteRegistryModal"
      :registryId="registryId"
      @closeModal="closeModalDeleteRegistry"
    />
    <div class="row border mx-2 mt-4 py-3">
      <div class="col-2">
        <img
          src="@/assets/img/grupo.png"
          class="d-none d-md-block"
          width="200"
        />
      </div>
      <div class="col-8 text-center py-3">
        <h1>REGISTROS DA QUALIDADE</h1>
      </div>
      <div class="col-2"></div>
    </div>
    <div class="row border mx-2 pt-3">
      <div class="col-6">
        <p>
          <strong>Status: </strong>
          <span v-html="statusRegistry(registry.status)" />
        </p>
      </div>
      <div class="col-6">
        <p>
          <strong>
            Nº do Registro:
            <span
              v-if="canEditRegistry"
              role="button"
              class="text-primary d-print-none"
              title="Editar"
              @click="editRegistry('numero')"
            >
              (Editar)
            </span>
            <span class="text-theme">{{ registry.numero }}</span>
          </strong>
        </p>
      </div>
    </div>
    <div class="row border mx-2 pt-3">
      <div class="col-6">
        <p>
          <strong>
            Data de Abertura:
            <span
              v-if="canEditRegistry"
              role="button"
              class="text-primary d-print-none"
              title="Editar"
              @click="editRegistry('dataAbertura')"
            >
              (Editar)
            </span>
          </strong>
          {{ dateSqlToDateBR(registry.dataAbertura) }}
        </p>
      </div>
      <div class="col-6">
        <p>
          <strong>Data de Encerramento:</strong>
          <span v-if="registry.status === 'Fechado'">
            {{ dateSqlToDateBR(registry.dataEncerramento) }}
          </span>
          <span v-else> - </span>
        </p>
      </div>
    </div>
    <div class="row border mx-2 pt-3">
      <div class="col-6">
        <p>
          <strong>
            Seção:
            <span
              v-if="canEditRegistry"
              role="button"
              class="text-primary d-print-none"
              title="Editar"
              @click="editRegistry('secao')"
            >
              (Editar)
            </span>
          </strong>
          {{ registry.secaoNome }}
        </p>
      </div>
      <div class="col-6">
        <p>
          <strong>
            Setor Responsável:
            <span
              v-if="canEditRegistry"
              role="button"
              class="text-primary d-print-none"
              title="Editar"
              @click="editRegistry('responsavel')"
            >
              (Editar)
            </span>
          </strong>
          {{ registry.responsavel }}
        </p>
      </div>
    </div>
    <div class="row border mx-2 pt-3">
      <div class="col-12 mb-2">
        <h5>
          Descrição
          <span v-if="registry.tipo === 'Planejamento de Mudanças'"> do </span>
          <span v-else>da</span>
          {{ registry.tipo }}:
          <span
            v-if="canEditRegistry"
            role="button"
            class="text-primary d-print-none"
            title="Editar"
            @click="editRegistry('tipo')"
          >
            (Editar)
          </span>
        </h5>
      </div>
      <div class="col-12">
        <p>
          <strong>
            Fato:
            <span
              v-if="canEditRegistry"
              role="button"
              class="text-primary d-print-none"
              title="Editar"
              @click="editRegistry('descricao')"
            >
              (Editar)
            </span>
          </strong>
          <span class="pre-line">{{ registry.descricao }}</span>
        </p>
      </div>
      <div class="col-12">
        <p>
          <strong>
            Risco:
            <span
              v-if="canEditRegistry"
              role="button"
              class="text-primary d-print-none"
              title="Editar"
              @click="editRegistry('risco')"
            >
              (Editar)
            </span>
          </strong>
          <span class="pre-line">{{ registry.risco }}</span>
        </p>
      </div>
      <div class="col-12">
        <p>
          <strong>
            Evidência:
            <span
              v-if="canEditRegistry"
              role="button"
              class="text-primary d-print-none"
              title="Editar"
              @click="editRegistry('evidencia')"
            >
              (Editar)
            </span>
          </strong>
          <span class="pre-line">{{ registry.evidencia }}</span>
        </p>
      </div>
      <div class="col-12">
        <p>
          <strong>
            Requisito:
            <span
              v-if="canEditRegistry"
              role="button"
              class="text-primary d-print-none"
              title="Editar"
              @click="editRegistry('requisito')"
            >
              (Editar)
            </span>
          </strong>
          <span class="pre-line">{{ registry.requisito }}</span>
        </p>
      </div>
    </div>
    <div class="row border mx-2 pt-3">
      <div class="col-12 mb-2">
        <h5>
          Ação de Correção (ação imediata para corrigir o problema):
          <span
            v-if="canEditRegistry"
            role="button"
            class="text-primary d-print-none"
            title="Editar"
            @click="editRegistry('acaoCorrecao')"
          >
            (Editar)
          </span>
        </h5>
      </div>
      <div class="col-12">
        <p>
          <span class="pre-line">{{ registry.acaoCorrecao }}</span>
        </p>
      </div>
    </div>
    <div class="row border mx-2 pt-3">
      <div class="col-12 mb-2">
        <h5>
          Identificação da causa da não conformidade:
          <span
            v-if="canEditRegistry"
            role="button"
            class="text-primary d-print-none"
            title="Editar"
            @click="editRegistry('causaNaoConformidade')"
          >
            (Editar)
          </span>
        </h5>
      </div>
      <div class="col-12">
        <p>
          <span class="pre-line">{{ registry.causaNaoConformidade }}</span>
        </p>
      </div>
    </div>
    <list-attachments :registryId="registryId" />
    <list-actions :registryId="registryId" />
    <div class="row border mx-2 pt-3">
      <div class="col-12">
        <p>
          <strong>Criado por: </strong>
          {{
            createdUpdatedUser(registry.usuarioCriacao, registry.dataCriacao)
          }}
        </p>
        <p v-if="registry.usuarioModificacao">
          <strong>Modificado por:</strong>
          {{
            createdUpdatedUser(
              registry.usuarioModificacao,
              registry.dataModificacao,
            )
          }}
        </p>
      </div>
    </div>
    <div class="text-right mt-4 d-print-none">
      <router-link
        to="/home"
        class="btn btn-outline-secondary mr-2"
        title="Voltar"
      >
        Voltar
      </router-link>
      <button
        v-if="isAdmin"
        class="btn btn-danger mr-2"
        title="Excluir Registro"
        @click="deleteRegistry()"
      >
        Excluir
      </button>
    </div>
  </div>
</template>

<script>
import PATHS from '@/router/routesMap'
import { mapGetters } from 'vuex'
import { createdUpdatedUser, statusRegistry } from '@/utils/strings'
import { dateSqlToDateBR } from '@/utils/date'
import LoadingData from '@/components/commons/LoadingData.vue'
import EditRegistryModal from '@/components/registries/EditRegistryModal.vue'
import ListAttachments from '@/components/attachments/ListAttachments.vue'
import ListActions from '@/components/actions/ListActions.vue'
import DeleteRegistryModal from '@/components/registries/DeleteRegistryModal.vue'

export default {
  name: 'DetailsRegistry',

  components: {
    LoadingData,
    EditRegistryModal,
    ListAttachments,
    ListActions,
    DeleteRegistryModal,
  },

  props: {
    registryId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      registry: {},
      showDeleteRegistryModal: false,
      showEditRegistryModal: false,
      fieldEdit: '',
      createdUpdatedUser,
      statusRegistry,
      dateSqlToDateBR,
    }
  },

  computed: {
    ...mapGetters(['reloadDetailsRegistry']),

    canEditRegistry() {
      return this.$store.getters.canEditRegistry
    },

    isAdmin() {
      return this.$store.getters.user.isAdmin
    },
  },

  watch: {
    reloadDetailsRegistry: {
      handler(newVal, oldVal) {
        if (newVal === true) {
          this.getRegistry()
          this.$store.dispatch('setReloadDetailsRegistry', false)
        }
      },
      immediate: true,
    },
  },

  methods: {
    async getRegistry() {
      try {
        this.registry = await this.$store.dispatch(
          'getRegistry',
          this.registryId,
        )
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$snotify.warning(error.message, 'Atenção!')
        } else {
          this.$snotify.error(
            'Não foi possível se conectar ao servidor.',
            'Erro!',
          )
        }
        this.$router.push(PATHS.HOME)
      }
    },

    editRegistry(field) {
      this.fieldEdit = field
      this.showEditRegistryModal = true
    },

    closeModalEditRegistry(reloadData) {
      if (reloadData) {
        this.getRegistry()
      }
      this.showEditRegistryModal = false
    },

    deleteRegistry() {
      this.showDeleteRegistryModal = true
    },

    closeModalDeleteRegistry(excluded) {
      this.showDeleteRegistryModal = false
      if (excluded) {
        this.$router.push(PATHS.HOME)
      }
    },
  },

  mounted() {
    this.getRegistry()
  },
}
</script>
